module.exports = __webpack_public_path__ + "img/office-3.a0c5b22d.png";